import { render } from "./AppBarComponent.vue?vue&type=template&id=48b3b29a&scoped=true"
import script from "./AppBarComponent.vue?vue&type=script&lang=js"
export * from "./AppBarComponent.vue?vue&type=script&lang=js"

import "./AppBarComponent.vue?vue&type=style&index=0&id=48b3b29a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b3b29a"]])

export default __exports__